import React, {useState} from "react";
import {Button} from "react-bootstrap";
import SignInModal from "./SignInModal";
import {useFetchSeasonByIdOrSlug, useSignInUserToASeason} from "../../features/season/seasonApi";
import SeasonRoundList from "./SeasonRoundList";
import {SignInUserToASeasonModel} from "../../features/season/seasonTypes";

type Props = {
    slug: string;
};

const SeasonContent = ({slug}: Props) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedCarId, setSelectedCarId] = useState<number | 0>(0);
    const {data:season} = useFetchSeasonByIdOrSlug(slug)
    const handleShowModal = () => setShowModal(true);

    const seasonID =  season?.id
    const { mutate } = useSignInUserToASeason(seasonID ?? 0);
    const submitSignIn = async (data: SignInUserToASeasonModel) => {
        try {
            const payload = {
                ...data,
                team_checkbox: true
            };
            const response = await mutate(payload);
            console.log("Sign-in successful: ", response);
        } catch (error) {
            console.error("Sign-in failed: ", error);
        }
    };
    if (!season) {
        return (<></>);
    }

    return (
        <section className="py-2">
            <SeasonRoundList season={season}/>
            <Button variant="primary" onClick={handleShowModal}>
                Sign In
            </Button>
            <SignInModal season={season} showModal={showModal} setShowModal={setShowModal}
                         setSelectedCarId={setSelectedCarId} selectedCarId={selectedCarId} onSubmit={submitSignIn}/>
        </section>
    );
};

export default SeasonContent;
